export enum InvoiceItemTypes {
  Discount = 1,
  Subscription = 2,
  Location = 3,
  Device = 4,
  Campaign = 5,
  SMS = 6,
}
